module.exports = {"TXTCLI_Overview":{"id":"TXTCLI_Overview","defaultMessage":"Vue d''ensemble","track":"Overview"}}